import { InjectionToken } from '@angular/core';

import { AddTeammatesDialogData } from '@ninety/platform/models/user/add-teammates-dialog-data';

import { DialogOpener, noopDialogRef } from './dialog-opener.type';

/**
 * Dialog-opener token for the add-teammates dialog (DEV-26105 T6c, Option B — the same token-inversion
 * mechanism as T6a's `auth-dialog.tokens` / T6b's `billing-dialog.tokens`). `AddTeammatesDialogComponent`
 * lives in `shared/ui/core`; importing it from `users-state.effects` would reopen the
 * `platform/state -> shared/ui/core` edge this epic exists to sever. `UsersStateEffects` also opens the
 * shared confirm dialog, but that reuses the existing `CONFIRM_DIALOG` token. Defaults to a no-op opener
 * and is bound at the app composition root via `users-dialog.providers.ts`.
 */
export const ADD_TEAMMATES_DIALOG = new InjectionToken<DialogOpener<AddTeammatesDialogData>>('ADD_TEAMMATES_DIALOG', {
  providedIn: 'root',
  factory: (): DialogOpener<AddTeammatesDialogData> => () => noopDialogRef(),
});
